import React from 'react'
import { useNavigate } from 'react-router-dom'
import { DcButton, PixelFactoryContext, PixelTable } from 'pixel-base'
import {
  getReconciliations,
  undoReconciliation,
} from 'utils/api-routes-accounts'
import FinancePageShell from '../../components/FinancePageShell'
import FinanceStatusBadge from '../../components/FinanceStatusBadge'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { Reconciliation } from '../../types/finance'
import formatFinanceDate from '../../utils/formatFinanceDate'

const ReconciliationPage = () => {
  const pixelFactory = React.useContext(PixelFactoryContext) as any
  const navigate = useNavigate()
  const reconciliations = useFinanceObservable<Reconciliation[]>(() =>
    getReconciliations(),
  )

  const undo = (id: number) => {
    undoReconciliation(id).subscribe({
      next: () => {
        pixelFactory?.showSuccess?.('Reconciliation undone')
        reconciliations.refresh()
      },
      error: () => pixelFactory?.showFailure?.('Unable to undo reconciliation'),
    })
  }

  return (
    <FinancePageShell
      title="Reconciliation"
      isLoading={reconciliations.loading}
    >
      <PixelTable
        columns={[
          { name: 'ID', selector: (row) => row.id },
          { name: 'Type', selector: (row) => row.reconciliation_type },
          { name: 'Lines', selector: (row) => row.lines?.length || 0 },
          {
            name: 'Created At',
            selector: (row) => formatFinanceDate(row.created_at),
          },
          {
            name: 'Status',
            selector: () => <FinanceStatusBadge status="reconciled" />,
          },
          {
            name: 'Actions',
            selector: (row) => (
              <div style={{ display: 'flex', gap: 8 }}>
                <DcButton
                  size="sm"
                  variant="outline-primary"
                  onClick={() => navigate(`/finance/reconciliation/${row.id}`)}
                >
                  View
                </DcButton>
                <DcButton
                  size="sm"
                  variant="outline-danger"
                  onClick={() => undo(row.id)}
                >
                  Undo
                </DcButton>
              </div>
            ),
          },
        ]}
        data={reconciliations.data || []}
        searchable
        pagination
      />
    </FinancePageShell>
  )
}

export default ReconciliationPage
